import { render } from "./OverviewHeader.vue?vue&type=template&id=321ff1c9&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=js"
export * from "./OverviewHeader.vue?vue&type=script&lang=js"

import "./OverviewHeader.vue?vue&type=style&index=0&id=321ff1c9&lang=scss&scoped=true"
import "./OverviewHeader.vue?vue&type=style&index=1&id=321ff1c9&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321ff1c9"]])

export default __exports__